
import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appAutoCapitalize]'
})
export class AutoCapitalizeDirective {
  constructor(private el: ElementRef) { }

  @HostListener('input', ['$event']) onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    input.value = input.value
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase());
  }
}
